import GetSchedulerByClassesRequestModel from '../../../generated/types/model/request/GetSchedulerByClassesRequestModel';

export default class GetSchedulerByClassesRequestViewModel extends GetSchedulerByClassesRequestModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
